<template>
  <v-dialog
    transition="fade-transition"
    persistent
    ref="dialog"
    v-model="isOpen"
    absolute
    hide-overlay
    :overlay-opacity="0"
  >
    <div class="card-overlay" @click="$refs.dialog.animateClick()" />

    <v-card style="width: 560px" class="" v-if="isOpen">
      <OnboardingNoActivePlans class="mx-auto mt-8" />

      <v-card-text height="800px" class="px-10 pt-8">
        <h4 class="text-center pb-6">{{ $t('heading.onboarding.noInstallationType.title') }}</h4>
        <v-btn x-small icon @click="$emit('remove-modal')" class="close-model">
          <v-icon>$close</v-icon>
        </v-btn>
        <p class="p-1 text-center">
          {{ $t('heading.onboarding.noInstallationType.info') }}
        </p>
      </v-card-text>
      <v-card-actions class="d-flex flex-column pb-4 px-10 pt-2">
        <v-btn
          x-large
          elevation="0"
          class="mx-0"
          @click="$emit('go-back')"
          color="gray"
          text
          block
        >
          <span class="p-1 font-weight-light gray--text text--darken-1">
            {{ $t('button.dashboard.back') }}
          </span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import OnboardingNoActivePlans from "../illustrations/onboarding-no-active-plans.vue";

export default {
  name: "OnboardingInstallationNoTypeModal",
  components: {
    OnboardingNoActivePlans,
  },
  props: {
    isOpen: Boolean,
  },
  watch: {
    isOpen: function (value) {
      value
        ? this.$store.dispatch("lockBodyScroll")
        : this.$store.dispatch("unlockBodyScroll");
    },
  },
};
</script>

<style lang="scss" scoped>
.v-dialog__content::v-deep {
  .v-dialog {
    overflow-y: auto;
    overflow-x: hidden;
  }
}

.close-model {
  position: absolute;
  top: -40px;
  right: -8px;
}
.v-card::v-deep {
  .v-card__text {
    -webkit-line-clamp: unset !important;
  }
  @media (max-width: 480px) {
    .v-card__text,
    .v-card__actions {
      padding-left: 24px !important;
      padding-right: 24px !important;
    }
  }
}
</style>
